import React from 'react'
import { Row } from 'react-bootstrap'
import { IProductBase } from '../../IProduct'
import ProductDescription, { TDescritionDisplay } from 'product/ProductDescription'
import { ICommonProductListItemProps } from '../IProductListItemProps'
import ProductItemHeaderWithImage from './ProductItemHeaderWithImage'
import ProductItemHeader from './ProductItemHeader'

interface IProductListItemProps_depr {
  showDescription?: TDescritionDisplay

  itemSize?: string
  showButton?: boolean
  buttonLabel?: string | React.ReactElement
  forbidden?: boolean
  onClick?: (product: IProductBase) => void
  style?: React.CSSProperties
}

interface IProductListItemProps extends ICommonProductListItemProps {
  showDescription?: TDescritionDisplay
  style?: React.CSSProperties
}

const ProductListItemView: React.FC<IProductListItemProps> = ({
  product,
  showDescription,
  style,
  children,
}) => {
  return (
    <Row style={style}>
      {product.images && product.images.length > 0 ? (
        <ProductItemHeaderWithImage product={product}>
          {children}
        </ProductItemHeaderWithImage>
      ) : (
        <ProductItemHeader product={product}>{children}</ProductItemHeader>
      )}

      <ProductDescription
        product={product}
        showDescription={showDescription}
        className='pt-2'
      />
    </Row>
  )
}
export default ProductListItemView

export type { IProductListItemProps_depr as IProductListItemProps }
